module.exports = __webpack_public_path__ + "static/media/admin-widgets.f048b958.png";